import { styled } from '@mui/material/styles'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useUserListActionsModal } from '../../contexts/UserListActionsModalContext'
import AdministrativeTabs from './AdministrativeTabs'

const BootstrapDialog = styled(Dialog)(() => ({
  '& .MuiDialogContent-root': {
    padding: 0,
    paddingLeft: 24,
    paddingRight: 24,
  },
  '& .MuiDialogActions-root': {
    paddingTop: 0,
    paddingLeft: 24,
    paddingRight: 24,
    paddingBottom: 32,
  },
}))

const UserListActionsModal = ({ onSend, enableAnnotations }) => {
  const { open, closeActionsModal, validateDisabledButton, handleSendClick } =
    useUserListActionsModal()

  const handleClick = () => {
    handleSendClick()
    onSend && onSend()
  }

  return (
    <BootstrapDialog
      onClose={closeActionsModal}
      aria-labelledby='adm-actions-title'
      open={open}
    >
      <DialogTitle id='adm-actions-title'>Status / Turno / Supervisão</DialogTitle>
      <IconButton
        aria-label='close'
        onClick={closeActionsModal}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: '#000',
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <AdministrativeTabs enableAnnotations={enableAnnotations} />
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={handleClick}
          variant='contained'
          disabled={validateDisabledButton()}
        >
          Enviar
        </Button>
      </DialogActions>
    </BootstrapDialog>
  )
}

export default UserListActionsModal
